module.exports = __webpack_public_path__ + "img/20170704_135648_093.e3c73673.jpg";